module.exports = __webpack_public_path__ + "media/images/org-ages-icon-b2b187a7.svg";